import { useContext } from 'react';
import { ChatResponseType } from '@trinity/chat';
import {
  type CustomResponseComponent,
  type CustomResponseInput,
  getCustomChatResponseDefinition,
} from '@trinity/custom-pages-registry';
import { CustomPageContextContainer } from '../CustomPageContext';
import { ChatMarkdown } from '../Markdown/Markdown';
import { ChatHintsLoadingContext, ChatInitialResponseContext } from './context';
import { AccountSearchResponse } from './Message.Response.AccountSearch';
import { HcpSearchResponse } from './Message.Response.HcpSearch';
import { RepSearchResponse } from './Message.Response.RepSearch';
import { BasicSystemUserMessage } from './Message.System.Basic';
import { SystemUserPlaceholderMessage } from './Message.System.Placeholder';

export const InitialSystemMessage = () => {
  const response = useContext(ChatInitialResponseContext);
  const loading = useContext(ChatHintsLoadingContext);

  if (loading || !response) {
    return <SystemUserPlaceholderMessage />;
  }

  if (response.type === ChatResponseType.HcpSearch) {
    return <HcpSearchResponse />;
  }

  if (response.type === ChatResponseType.Markdown) {
    return (
      <BasicSystemUserMessage>
        <ChatMarkdown value={response.value} />
      </BasicSystemUserMessage>
    );
  }

  if (response.type === ChatResponseType.RepSearch) {
    return <RepSearchResponse />;
  }

  if (response.type === ChatResponseType.AccountSearch) {
    return <AccountSearchResponse />;
  }

  const customResponseDefinition = getCustomChatResponseDefinition(response.type);
  if (customResponseDefinition && customResponseDefinition.renderInInitialMessage === true) {
    const Component = customResponseDefinition.component as CustomResponseComponent;

    return (
      <BasicSystemUserMessage>
        <CustomPageContextContainer>
          <Component response={response as CustomResponseInput} />
        </CustomPageContextContainer>
      </BasicSystemUserMessage>
    );
  }

  const responseHints = response.type === ChatResponseType.InitialGreeting ? response.data.hints : [];

  return (
    <BasicSystemUserMessage hints={responseHints}>
      <ChatMarkdown value={response.value} />
    </BasicSystemUserMessage>
  );
};
